import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-clients',
  templateUrl: './home-clients.component.html',
  styleUrls: ['./home-clients.component.css']
})
export class HomeClientsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
